/**
 * Created by Allan on 2022/04/09.
 * Contact 84880528@qq.com.
 * 取掉value的 %，并转换成为数字
 */
export default function(value){
    if(!value) return '';
    if(value==='-') return 0
    return Number(value.replace('%',''))
}



// WEBPACK FOOTER //
// ./src/filter/percentageNum.js